var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-btn',_vm._g({style:(_vm.customText),attrs:{"text":""}},on),[_vm._v(_vm._s(_vm.mail))])]}}])},[_c('span',{staticClass:"tooltip-custom"},[_vm._v("Replace [AT] to @")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }